module.exports = __webpack_public_path__ + "media/images/icons/paperclip-d204f70e980310db757b2eadf5840a12.svg";